import * as actionTypes from "./actionTypes";
import * as types from "./types";


// DELETE subscription

export const deleteSubscriptionReq = (
    params: string,
    subscriptionType: string
  ): types.DeleteSubscriptionRequest => ({
    type: actionTypes.DELETE_SUBSCRIPTION_REQUEST,
    params,
    subscriptionType
  });
  
  export const deleteSubscriptionSuccess = (
    success: types.IDeleteSubscriptionSuccessPayload
  ): types.DeleteSubscriptionSuccess => ({
    type: actionTypes.DELETE_SUBSCRIPTION_SUCCESS,
    success,
  });
  
  export const deleteSubscriptionFailure = (
    payload: types.IDeleteSubscriptionFailurePayload
  ): types.DeleteSubscriptionFailure => ({
    type: actionTypes.DELETE_SUBSCRIPTION_FAILURE,
    payload,
  });

  export const deleteSubscriptionReset = (): types.DeleteSubscriptionReset => ({
    type: actionTypes.DELETE_SUBSCRIPTION_RESET,
  });

  // POST subscription

export const postSubscriptionRequest = (
  payload: types.ISubscriptionPostReq
): types.PostSubscriptionRequest => ({
  type: actionTypes.POST_SUBSCRIPTION_REQUEST,
  payload,
});

export const postSubscriptionSuccess = (
  payload: types.IPostSubscriptionSuccessPayload
): types.PostSubscriptionSuccess => ({
  type: actionTypes.POST_SUBSCRIPTION_SUCCESS,
  payload,
});

export const postSubscriptionFailure = (
  payload: types.IPostSubscriptionFailurePayload
): types.PostSubscriptionFailure => ({
  type: actionTypes.POST_SUBSCRIPTION_FAILURE,
  payload,
});

export const postSubscriptionReset = (): types.PostSubscriptionReset => ({
  type: actionTypes.POST_SUBSCRIPTION_RESET,
});

// POST Extractor Subsription

export const postExtractorSubscriptionRequest = (
  batchCode: string,
  payload: types.IExtractorSubscriptionPostReq
): types.PostExtractorSubscriptionRequest => ({
  type: actionTypes.POST_EXTRACTOR_SUBSCRIPTION_REQUEST,
  payload,
  batchCode,
});

export const postExtractorSubscriptionSuccess = (
  payload: types.IPostExtractorSubscriptionSuccessPayload
): types.PostExtractorSubscriptionSuccess => ({
  type: actionTypes.POST_EXTRACTOR_SUBSCRIPTION_SUCCESS,
  payload,
});

export const postExtractorSubscriptionFailure = (
  payload: types.IPostExtractorSubscriptionFailurePayload
): types.PostExtractorSubscriptionFailure => ({
  type: actionTypes.POST_EXTRACTOR_SUBSCRIPTION_FAILURE,
  payload,
});

export const postExtractorSubscriptionReset = (): types.PostExtractorSubscriptionReset => ({
  type: actionTypes.POST_EXTRACTOR_SUBSCRIPTION_RESET,
});

//Get all subscriptions
export const fetchSubscriptionRequest = (
  params: types.ISubscriptionSearchParams
): types.FetchSubscriptionReq => ({
  type: actionTypes.FETCH_SUBSCRIPTION_LIST_REQUEST,
  params: params,
});

export const fetchSubscriptionSuccess = (
  payload: types.FetchSubscriptionSuccessPayload
): types.FetchSubscriptionSuccess => ({
  type: actionTypes.FETCH_SUBSCRIPTION_LIST_SUCCESS,
  payload,
});

export const fetchSubscriptionFailure = (
  payload: types.FetchSubscriptionFailurePayload
): types.FetchSubscriptionFailure => ({
  type: actionTypes.FETCH_SUBSCRIPTION_LIST_FAILURE,
  payload,
});

export const fetchSubscriptionReset = (): types.FetchSubscriptionReset => ({
  type: actionTypes.FETCH_SUBSCRIPTION_LIST_RESET,
});
  